export const actionTypes = {
  // Modal
  MAIN_MODAL_CLOSE: "modal:close",
  MAIN_MODAL_OPEN: "modal:open",

  // Keycloak
  APPEND_KEYCLOAK_DETAILS: "keycloak:AppendDetails",
  ACCOUNT_LOGOUT: "keycloak:Accountlogout",

  // Sales Service
  REPORTS_SALES_GET_OVERALL_AVERAGE: "sales:GetOverAllAverage",
  REPORTS_SALES_GET_CLUSTER_AVERAGE: "sales:GetClusterAverage",
  REPORTS_SALES_GET_AREA_AVERAGE: "sales:GetAreaAverage",
  REPORTS_SALES_GET_BRANCH_AVERAGE: "sales:GetBranchAverage",

  REPORTS_SALES_GET_OVERALL_ACTIVE: "sales:GetOverAllActive",
  REPORTS_SALES_GET_CLUSTER_ACTIVE: "sales:GetClusterActive",
  REPORTS_SALES_GET_AREA_ACTIVE: "sales:GetAreaActive",
  REPORTS_SALES_GET_BRANCH_ACTIVE: "sales:GetBranchActive",

  REPORTS_SALES_GET_OVERALL_EXPIRED: "sales:GetOverAllExpired",
  REPORTS_SALES_GET_CLUSTER_EXPIRED: "sales:GetClusterExpired",
  REPORTS_SALES_GET_AREA_EXPIRED: "sales:GetAreaExpired",
  REPORTS_SALES_GET_BRANCH_EXPIRED: "sales:GetBranchExpired",

  // Branch Category Service
  REPORTS_BRANCHCATEGORY_GET_OVERALL: "branchCategory:GetOverall",
  REPORTS_BRANCHCATEGORY_GET_CLUSTER: "branchCategory:GetCluster",
  REPORTS_BRANCHCATEGORY_GET_AREA: "branchCategory:GetArea",
  REPORTS_BRANCHCATEGORY_GET_BRANCH: "branchCategory:GetBranch",

  // Package Service
  REPORTS_PACKAGE_GET_OVERALL: "package:GetOverall",
  REPORTS_PACKAGE_GET_CLUSTER: "package:GetCluster",
  REPORTS_PACKAGE_GET_AREA: "package:GetArea",
  REPORTS_PACKAGE_GET_BRANCH: "package:GetBranch",
  REPORTS_DAILY_PACKAGE_GET_OVERALL: "package:GetDailyOverall",
  REPORTS_DAILY_PACKAGE_GET_CLUSTER: "package:GetDailyCluster",
  REPORTS_DAILY_PACKAGE_GET_AREA: "package:GetDailyArea",
  REPORTS_DAILY_PACKAGE_GET_BRANCH: "package:GetDailyBranch",

  // Unredeemed Pawns
  REPORTS_UNREDEEMEDPAWNS_GET_OVERALL: "unredeemed_pawns:GetOverall",
  REPORTS_UNREDEEMEDPAWNS_GET_CLUSTER: "unredeemed_pawns:GetCluster",
  REPORTS_UNREDEEMEDPAWNS_GET_AREA: "unredeemed_pawns:GetArea",
  REPORTS_UNREDEEMEDPAWNS_GET_BRANCH: "unredeemed_pawns:GetBranch",

  // Customer Profiling
  REPORTS_CUSTOMERPROFILING_GET_OVERALL: "customer_profiling:GetOverall",
  REPORTS_CUSTOMERPROFILING_GET_CLUSTER: "customer_profiling:GetCluster",
  REPORTS_CUSTOMERPROFILING_GET_AREA: "customer_profiling:GetArea",
  REPORTS_CUSTOMERPROFILING_GET_BRANCH: "customer_profiling:GetBranch",

  REPORTS_DAILY_CUSTOMERPROFILING_GET_OVERALL: "customer_profiling:GetDailyOverall",
  REPORTS_DAILY_CUSTOMERPROFILING_GET_CLUSTER: "customer_profiling:GetDailyCluster",
  REPORTS_DAILY_CUSTOMERPROFILING_GET_AREA: "customer_profiling:GetDailyArea",
  REPORTS_DAILY_CUSTOMERPROFILING_GET_BRANCH: "customer_profiling:GetDailyBranch",

  // Previous Month Average
  REPORTS_PREVIOUSMONTH_AVERAGE_GET_CLUSTER: "previous_month_average:GetCluster",
  REPORTS_PREVIOUSMONTH_AVERAGE_GET_AREA: "previous_month_average:GetArea",
  REPORTS_PREVIOUSMONTH_AVERAGE_GET_BRANCH: "previous_month_average:GetBranch",
  REPORTS_PREVIOUSMONTH_AVERAGE_SET_SCOPE_DATE: "previous_month_average:SetScopeDate",

  // Inventory Target
  REPORTS_INVENTORY_TARGET_GET_OVERALL: "inventory_target:GetOverall",
  REPORTS_INVENTORY_TARGET_GET_CLUSTER: "inventory_target:GetCluster",
  REPORTS_INVENTORY_TARGET_GET_AREA: "inventory_target:GetArea",
  REPORTS_INVENTORY_TARGET_GET_BRANCH: "inventory_target:GetArea",

  // Daily Summary
  REPORTS_DAILY_SUMMARY_GET_OVERALL: "daily_summary:GetOverall",
  REPORTS_DAILY_SUMMARY_GET_CLUSTER: "daily_summary:GetCluster",
  REPORTS_DAILY_SUMMARY_TARGET_GET_AREA: "daily_summary:GetArea",
  REPORTS_DAILY_SUMMARY_TARGET_GET_BRANCH: "daily_summary:GetBranch",

  // Profit Breakdown
  REPORTS_PROFIT_BREAKDOWN_GET_OVERALL: "profit_breakdown:GetOverall",
  REPORTS_PROFIT_BREAKDOWN_GET_CLUSTER: "profit_breakdown:GetCluster",
  REPORTS_PROFIT_BREAKDOWN_TARGET_GET_AREA: "profit_breakdown:GetArea",
  REPORTS_PROFIT_BREAKDOWN_TARGET_GET_BRANCH: "profit_breakdown:GetBranch",

  // Inventory Details
  REPORTS_INVENTORY_DETAILS_GET_OVERALL: "inventory_details:GetOverall",
  REPORTS_INVENTORY_DETAILS_GET_CLUSTER: "inventory_details:GetCluster",
  REPORTS_INVENTORY_DETAILS_TARGET_GET_AREA: "inventory_details:GetArea",
  REPORTS_INVENTORY_DETAILS_TARGET_GET_BRANCH: "inventory_details:GetBranch",

  // CRDM
  CRDM_GET_CLUSTERS: "crdm:GetClusters",
  CRDM_GET_AREAS: "crdm:GetAreas",
  CRDM_GET_MASTER_CLUSTERS: "crdm:GetMasterClusters",
  CRDM_GET_MASTER_AREAS: "crdm:GetMasterAreas",
  CRDM_GET_PEPP_HIERARCHY: "crdm:GetPeppHeirarchy",
  CRDM_GET_PEPP_BRANCH: "crdm:GetBranch",

  // Reports Settings Branch
  REPORTS_SETTINGS_BRANCH_TARGET_GET_COLLECTION: "reports_settings:GetBranchCollection",
  REPORTS_SETTINGS_BRANCH_TARGET_GET_SINGLE: "reports_settings:GetBranchSingle",
  REPORTS_SETTINGS_BRANCH_TARGET_ADD: "reports_settings:AddBranch",
  REPORTS_SETTINGS_BRANCH_TARGET_UPDATE: "reports_settings:UpdateBranch",
  REPORTS_SETTINGS_BRANCH_TARGET_DELETE: "reports_settings:DeleteBranch",

  // Reports Settings Area
  REPORTS_SETTINGS_AREA_TARGET_GET_COLLECTION: "reports_settings:GetAreaCollection",
  REPORTS_SETTINGS_AREA_TARGET_GET_SINGLE: "reports_settings:GetAreaSingle",
  REPORTS_SETTINGS_AREA_TARGET_ADD: "reports_settings:AddArea",
  REPORTS_SETTINGS_AREA_TARGET_UPDATE: "reports_settings:UpdateArea",
  REPORTS_SETTINGS_AREA_TARGET_DELETE: "reports_settings:DeleteArea",

  // Reports Settings Cluster
  REPORTS_SETTINGS_CLUSTER_TARGET_GET_COLLECTION: "inventory_details:GetClusterCollection",
  REPORTS_SETTINGS_CLUSTER_TARGET_GET_SINGLE: "reports_settings:GetClusterSingle",
  REPORTS_SETTINGS_CLUSTER_TARGET_ADD: "reports_settings:AddCluster",
  REPORTS_SETTINGS_CLUSTER_TARGET_UPDATE: "reports_settings:UpdateCluster",
  REPORTS_SETTINGS_CLUSTER_TARGET_DELETE: "reports_settings:DeleteCluster",

  // Reports Settings Overall
  REPORTS_SETTINGS_OVERALL_TARGET_GET_COLLECTION: "inventory_details:GetOverallCollection",
  REPORTS_SETTINGS_OVERALL_TARGET_GET_SINGLE: "reports_settings:GetOverallSingle",
  REPORTS_SETTINGS_OVERALL_TARGET_ADD: "reports_settings:AddOverall",
  REPORTS_SETTINGS_OVERALL_TARGET_UPDATE: "reports_settings:UpdateOverall",
  REPORTS_SETTINGS_OVERALL_TARGET_DELETE: "reports_settings:DeleteOverall",

  // Branch Category Settings
  REPORTS_SETTINGS_BRANCH_CATEGORY_COLLECTION: "inventory_details:GetBranchCategoryCollection",
  REPORTS_SETTINGS_BRANCH_CATEGORY_GET_SINGLE: "reports_settings:GetBranchCategorySingle",
  REPORTS_SETTINGS_BRANCH_CATEGORY_ADD: "reports_settings:AddBranchCategory",
  REPORTS_SETTINGS_BRANCH_CATEGORY_UPDATE: "reports_settings:UpdateBranchCategory",
  REPORTS_SETTINGS_BRANCH_CATEGORY_DELETE: "reports_settings:DeleteBranchCategory",

  // Chart Titles
  CHART_TITLE_SET_TITLES: "chart_title:setTitles",
  CHART_TITLE_CLEAR_TITLES: "chart_title:clearTitles",
  CHART_TITLE_SET_RANKING: "chart_title:setRanking",
  CHART_TITLE_SET_SALES_AVERAGE: "chart_title:setSalesAverage",
  CHART_TITLE_SET_SALES_ACTIVE: "chart_title:setSalesActive",
  CHART_TITLE_SET_SALES_EXPIRED: "chart_title:setSalesExpired",
  CHART_TITLE_SET_INVENTORY_TARGET: "chart_title:setInventoryTarget",
  CHART_TITLE_SET_BRANCH_CATEGORIES: "chart_title:setBranchCategory",
  CHART_TITLE_SET_CUSTOMER_PROFILING: "chart_title:setCustomerProfiling",
  CHART_TITLE_SET_UNREDEEMED_PAWN: "chart_title:setUnredeemedPawn",
  CHART_TITLE_SET_PACKAGES: "chart_title:setPackage",
};